import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { imgUrl } from "@/lib/api";
import { money } from "@/lib/booking";
import { Reveal, Overline } from "@/components/site/Reveal";

export const OtherUnits = ({ units }) => {
  const { t, pick } = useI18n();
  if (!units?.length) return null;
  return (
    <section data-testid="other-units-section" className="mx-auto max-w-[1280px] border-t border-ink/10 px-5 py-20 sm:px-8">
      <Overline>Sámara · Guanacaste</Overline>
      <h3 className="mt-3 font-display text-4xl text-ink">{t("st.title")}</h3>
      <div className="mt-10 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
        {units.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.08}>
            <Link to={`/stay/${p.slug}`} data-testid={`unit-card-${p.slug}`} className="group block" onClick={() => window.scrollTo(0, 0)}>
              <div className="aspect-[4/3] overflow-hidden rounded-[24px] bg-paper2">
                <img src={imgUrl(p.photos?.[0]?.url || "/images/p16.jpg")} alt={p.name} className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
              </div>
              <div className="mt-4 flex items-start justify-between gap-3">
                <div>
                  <p className="font-display text-2xl text-ink">{p.name}</p>
                  <p className="line-clamp-1 text-sm text-muted2">{pick(p.title)}</p>
                </div>
                {p.rating > 0 && <span className="flex items-center gap-1 text-sm"><Star className="h-3.5 w-3.5 fill-ink" />{p.rating}</span>}
              </div>
              <p className="mt-1 text-sm"><span className="font-semibold">{money(p.price_per_night)}</span> / {t("w.night")}</p>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
